import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from 'store/actions/checkout';

export const checkoutReducer = createReducer<{}, ActionType<typeof actions>>({})
  .handleAction(actions.handleModal402, (state, { payload }) => ({
    ...state,
    ...payload,
  }))
  .handleAction(actions.handleScreen412, (state, { payload }) => ({
    ...state,
    ...payload,
  }));
